import connectQbooksLarge from '!!url-loader!./assets/connectQbooksLarge.svg';
import connectQbooksLargeHover from '!!url-loader!./assets/connectQbooksLargeHover.svg';
import connectQbooksMedium from '!!url-loader!./assets/connectQbooksMedium.svg';
import connectQbooksMediumHover from '!!url-loader!./assets/connectQbooksMediumHover.svg';
import connectQbooksSmall from '!!url-loader!./assets/connectQbooksSmall.svg';
import connectQbooksSmallHover from '!!url-loader!./assets/connectQbooksSmallHover.svg';

import { ConnectQuickBooksButtonProps } from './ConnectQuickBooksButton.types';

export const useConnectQuickBooksButton = (size: ConnectQuickBooksButtonProps['size']) => {
    switch (size) {
        case 'small':
            return {
                width: 190,
                height: 28,
                backgroundImage: connectQbooksSmall,
                backgroundImageHover: connectQbooksSmallHover,
            };
        case 'large':
            return {
                width: 297,
                height: 52,
                backgroundImage: connectQbooksLarge,
                backgroundImageHover: connectQbooksLargeHover,
            };
        case 'medium':
        default:
            return {
                width: 248,
                height: 40,
                backgroundImage: connectQbooksMedium,
                backgroundImageHover: connectQbooksMediumHover,
            };
    }
};
